module.exports = __webpack_public_path__ + "static/kobold_scale_sorcerer-694aa0cf0081ba574c5081c7f6c991a8.jpeg";